// companyInfoFields.ts
const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/
  ///^\d{0,2}+(\.\d{0,2})?$/
}

export const companyInfoFields = [
  {
    id: "clientName",
    label: "Client Name",
    placeHolder: "Enter client name",
    type: "text",
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC
  },
  {
    id: "companyName",
    label: "Company Name",
    placeHolder: "Enter company name",
    type: "text",
    isRequired: true,
    editReadOnly: true
  },
  {
    id: "registrationDate",
    label: "Registration Date",
    placeHolder: "Select",
    type: "date",
  },
  {
    id: "phoneNumber",
    label: "Phone Number",
    placeHolder: "Enter phone number",
    type: "text",
    // isRequired: true,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC
  },
  {
    id: "address",
    label: "Address",
    placeHolder: "Enter Address",
    type: "text",
    isRequired: true,
  },
  {
    id: "postCode",
    label: "Post Code",
    placeHolder: "Enter Postcode",
    type: "text",
    isRequired: true,
    patternAllowed: patternConstant?.ALPHANUMERIC
  },
  {
    id: "companyStrapLine",
    label: "Company Strap Line",
    placeHolder: "Enter company description",
    type: "text",
  },
  {
    id: "vatPercent",
    label: "VAT Percentage",
    placeHolder: "Enter VAT Percentage",
    type: "text",
    isRequired: true,
    patternAllowed: patternConstant?.PERCENTAGE
  },
  {
    id: "vatRegNo",
    label: "VAT Reg. No.",
    placeHolder: "Enter VAT Reg. No.",
    type: "string",
    isRequired: true,
    editReadOnly: true,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC
  },
  {
    id: "dateFormat",
    label: "Date Format",
    placeHolder: "DD/MM/YYYY",
    type: "select",
    options: [
      "DD/MM/YYYY",
      "MM/DD/YYYY",
      "YYYY/MM/DD",
      "YYYY-MM-DD",
      "DD-MM-YYYY",
      "MM-DD-YYYY",
    ],
    isRequired: true,
  },
  {
    id: "companyRegNo",
    label: "Company Reg. No.",
    placeHolder: "Enter company reg. no.",
    type: "text",
    patternAllowed: patternConstant?.ALPHANUMERIC
  },
  {
    id: "generalWebsite",
    label: "General Website",
    placeHolder: "Enter general website",
    type: "text",
  },
];

// subscription plan
export const subscriptionPlanFields = [
  {
    id: "planId",
    label: "Subscription",
    placeHolder: "select",
    type: "select",
    options: [],
  },
  {
    id: "duration",
    label: "Duration",
    placeHolder: "select",
    type: "select",
    options: ["5 Days Trial", "3 Months", "6 Months", "12 Months"],
  },
  {
    id: "term",
    label: "Term",
    placeHolder: "select",
    type: "daterange",
  },
  {
    id: "renewsOn",
    label: "Renews On",
    placeHolder: "Enter action",
    type: "text",
    disabled: true
  },
  {
    id: "subscriptionCost",
    label: "Subscription Cost",
    placeHolder: "Enter subscription cost",
    type: "number",
    disabled: true
  },
  {
    id: "discount",
    label: "Discount",
    placeHolder: "Enter discount",
    type: "text",
    patternAllowed: patternConstant?.PERCENTAGE
  },
  {
    id: "amountPayable",
    label: "Amount Payable",
    placeHolder: "Enter payable amount",
    type: "number",
    disabled: true,
  },
  {
    id: "paymentMethod",
    label: "Payment Method",
    placeHolder: "select",
    type: "select",
    options: ["Direct Debit","Cardless Payment"],
  },
  // {
  //   id: "cardNumber",
  //   label: "Card Number",
  //   placeHolder: "Enter card number",
  //   type: "text",
  // },
  // {
  //   id: "expiryDate",
  //   label: "Expiry Date",
  //   placeHolder: "select",
  //   type: "date",
  // },
];

// financial Info
export const FinancialInfoFields = [
  {
    id: "invoiceAddress",
    label: "Invoice Address",
    placeHolder: "Enter invoice address",
    type: "text",
    isRequired: true,
  },
  {
    id: "isSameWithCompanyAddress",
    label: "Same as the company's",
    placeHolder: "select",
    type: "checkbox",
  },
  {
    id: "paymentTerms",
    label: "Payment Terms",
    placeHolder: "Enter payment terms",
    type: "text",
    isRequired: true,
  },
  {
    id: "bankSortCode",
    label: "Bank Sort Code",
    placeHolder: "Enter bank sort code",
    type: "text",
  },
  {
    id: "bankAccountNumber",
    label: "Bank Account No.",
    placeHolder: "Enter bank account number",
    type: "text",
  },
  {
    id: "IBAN",
    label: "IBAN",
    placeHolder: "Enter iban number",
    type: "text",
  },
  {
    id: "swiftNumber",
    label: "SWIFT No.",
    placeHolder: "Enter swift number",
    type: "text",
  },
  {
    id: "bankName",
    label: "Bank Name",
    placeHolder: "Enter bank name",
    type: "text",
  },
  {
    id: "extendedLiabilityPercent",
    label: "Extended Liability %",
    placeHolder: "Enter extend liability",
    type: "text",
    patternAllowed: patternConstant?.PERCENTAGE
  },
  {
    id: "extendedLiabilityTax",
    label: "Extended Liability Tax",
    placeHolder: "Enter extend liability tax",
    type: "text",
    patternAllowed: patternConstant?.PERCENTAGE
  },
  {
    id: "insuranceFixedRate",
    label: "Insurance Fixed Rate",
    placeHolder: "Enter insurance fixed rate",
    type: "text",
    patternAllowed: patternConstant?.PERCENTAGE
  },
];

//Email Settings
export const emailSettingFields = [
  {
    id: "email",
    label: "Email",
    placeHolder: "Enter email ID",
    type: "text",
    isRequired: true,
    editReadOnly: true
  },
  {
    id: "notificationEmail",
    label: "Customer Service",
    placeHolder: "Enter email ID",
    type: "text",
    autocomplete: "off"
  },
  // {
  //   id: "emailPassword",
  //   label: "Email Password",
  //   placeHolder: "Enter email ID",
  //   type: "password",
  //   autocomplete: "off"
  // },
  {
    id: "emailSignature",
    label: "Email Signature",
    placeHolder: "Enter email signature",
    type: "text",
    autocomplete: "off"
  },
  {
    id: "emailDisclaimer",
    label: "Email Disclaimer",
    placeHolder: "Enter disclaimer",
    type: "text",
    autocomplete: "off"
  },
];
